import { nebankaOcpAccountCanceledOrdersRoute } from '../NebankaOcpAccountCanceledOrdersPage/route';
import { nebankaOcpAccountOrdersRoute } from '../NebankaOcpAccountOrdersPage/route';
import { nebankaOcpAccountPendingOrdersRoute } from '../NebankaOcpAccountPendingOrdersPage/route';
import { nebankaOcpAccountTransactionsRoute } from '../NebankaOcpAccountTransactionsPage/route';

import { nebankaOcpRoute } from './route';

export const nebankaOcpRoutes = nebankaOcpRoute.addChildren([
	nebankaOcpAccountTransactionsRoute,
	nebankaOcpAccountOrdersRoute,
	nebankaOcpAccountPendingOrdersRoute,
	nebankaOcpAccountCanceledOrdersRoute,
]);
